// extracted by mini-css-extract-plugin
module.exports = {"parentsSpinner":"LoadingSpinner_parentsSpinner__tzZ2B","spinner":"LoadingSpinner_spinner__rJnWW"};